var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path)?_c('path',{class:['area', { hovered: _vm.hoveredStacked === _vm.serie.key }],attrs:{"d":_vm.path +
    (_vm.previousPath ||
      ("V\n" + (this.p.scaleY(this.p.minY)) + " H " + (this.p.scaleX(_vm.p.minX)) + " Z")),"fill":_vm.hoveredStacked === _vm.serie.key
      ? 'rgba(255, 255, 255, 0.2)'
      : 'rgba(255, 255, 255, 0.1)'}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }